import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import { app } from "./config";

let analyticsInstance = null;
let initialized = false;

const initAnalytics = async () => {
  if (initialized) return analyticsInstance;

  const supported = await isSupported();
  console.log("Analytics supported:", supported);

  if (supported) {
    analyticsInstance = getAnalytics(app);
    console.log("Analytics initialized");
  } else {
    console.log("Analytics not supported in this environment");
  }

  initialized = true;
  return analyticsInstance;
};

export const trackEvent = async (eventName, params = {}) => {
  console.log("TRACK EVENT FIRED:", eventName, params);

  const analytics = await initAnalytics();

  if (analytics) {
    console.log("Sending event to Firebase Analytics");
    logEvent(analytics, eventName, params);
  } else {
    console.log("No analytics instance available");
  }
};
// ✅ ADD THIS
export const trackPageView = async (pagePath, pageTitle = document.title) => {
  const analytics = await initAnalytics();

  if (analytics) {
    logEvent(analytics, "page_view", {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: pageTitle,
    });
  }
};
